declare namespace $ {

	type $mol_link__arg_bog_blitz_blog_page_1 = $mol_type_enforce<
		({ 
			'screen': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_blitz_blog_page_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_text__text_bog_blitz_blog_page_3 = $mol_type_enforce<
		ReturnType< $bog_blitz_blog_page['article_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_link_iconed__uri_bog_blitz_blog_page_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_iconed['uri'] >
	>
	type $mol_link_iconed__title_bog_blitz_blog_page_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_iconed['title'] >
	>
	export class $bog_blitz_blog_page extends $mol_page {
		article_title( ): string
		Back_icon( ): $mol_icon_arrow_left
		Back( ): $mol_link
		article_text( ): string
		Content( ): $mol_text
		App_link( ): $mol_link_iconed
		slug( ): string
		title( ): ReturnType< $bog_blitz_blog_page['article_title'] >
		head( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map